export const isTemplate = function (name, suffix = '') {
  return document.documentElement.classList.contains(
    `template-${name}-${suffix ? suffix : 'default'}`,
  );
}

export const loadsSection = function (sectionHandle) {
  return !!document.querySelector(`[data-section-type="${sectionHandle}"]`);
}

export const camelize = function (str) {
  let arr = str.split('-');
  let capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item);
  // ^-- change here.
  let capitalString = capital.join("");
  return capitalString;
}

export const dependenciesCheck = function () {
  var passed = true;

  for (var i = 0; i < arguments.length; i++) {
    var argBooleanValue = !!(typeof arguments[i] === 'string' || arguments[i] instanceof jQuery ? arguments[i].length : arguments[i]);
    passed = (passed && argBooleanValue);
  }

  return passed;
};

export const isTouchDevice = function () {
  return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
};

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 *`{leading: false}`. To disable execution on the trailing edge, ditto.
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export const throttle = function (func, wait, options) {
  var context, args, result
  var timeout = null
  var previous = 0
  if (!options) options = {}
  var later = function () {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function () {
    var now = Date.now()
    if (!previous && options.leading === false) previous = now
    var remaining = wait - (now - previous)
    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

export const announcementBarHeight = () => {
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    return announcementBar.offsetHeight;
  } else {
    return 0;
  }
}

export const headerHeight = function () {
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const header = siteHeader.querySelector('.header__container');
    if (header) {
      if (siteHeader.classList.contains('headroom--unpinned')) {
        return header.offsetHeight;
      } else {
        return header.offsetHeight + announcementBarHeight();
      }
    } else {
      if (siteHeader.classList.contains('headroom--unpinned')) {
        return 0;
      } else {
        return announcementBarHeight();
      }
    }
  } else {
    return 0;
  }
}

export const addDelegatedEventListener = function (parentEl, eventType, targetSelector, callback) {
  parentEl.addEventListener(eventType, (event) => {
    const element = event.target.closest(targetSelector);

    if (!element) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (typeof callback === 'function') {
      callback(event, element, parent);
    }
  })
}

export const updateHeaderHeightVars = function () {
  document.documentElement.style.setProperty('--header-height', headerHeight() + 'px');
}

export const addStickyListener = function (target, callback) {
  // BEWARE MY FELLOW DEV FRIENDS!!! THIS IS A HACK!
  // And it needs top: -1px (or bottom, or whatever your using to stick your element in its position) on target to work properly
  if (!target || !(target instanceof HTMLElement) || typeof callback !== 'function') {
    console.warn('Target or callback are not defined correctly');
    return;
  }
  // Callback receives an array as input where first index is the event
  // es: ([e]) => 'callback body';
  const observer = new IntersectionObserver(callback, {
    threshold: [1]
  });

  observer.observe(target);
}
